<template>
  <div class="container-fluid">
    <div id="myModal" class="myModal" v-show="showModal">
      <div class="modalContent">
        <div style="position: relative; width: 0; height: 0; float: right;">
          <div class="close" @click="showModal = false">&times;</div>
        </div>
        <div class="modal-iframe">
          <iframe class="mondayIframe" src="https://forms.monday.com/forms/embed/e657a7fa0f32e0705d6ef4a6d3c04ae2" width="650" style="border: 0; width: 100%;"></iframe>
        </div>
      </div>
    </div>
    <div>
      <div class="row whiteRow top3 bottom13">
        <!--div class="col-md-1"></div-->
        <div class="col-md-3 col-sm-1 col-xs-1 offset-sm-0 offset-xs-0 paddingLeftSideSpecial5">
          <div class="leadLogo">
            <img src="../assets/CMwithBot&NES-Website.png" width="220" height="60" onclick="window.open('https://www.chatmanaging.com/', '_self')">
          </div>
        </div>
        <div class="col-md-3 col-sm-1 col-xs-1 offset-md-6 offset-sm-10">
          <div class="text-center">
            <input type="button" class="btn redButton" value="Request A Demo" onclick="window.open('https://www.leadmanaging.com/book-a-demo')"/>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="row whiteRow bottom13">
        <div class="col-md-4 offset-md-1 col-sm-12 col-xs-12 paddingLeftSide5">
          <div class="row textFormatting">
            <p class="headline">The Chatbot for property managers.</p>
          </div>
          <div class="row textFormatting extraSpace">
            <p class="subline">Providing a custom 24/7 experience for prospects through artificial intelligence. Made to enhance the leasing process.</p>
          </div>
          <div class="row extraSpace top3">
            <input type="button" class="btn whiteGreyRedButton" value="Sign Up" @click="showModal = true"/>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12">
          <img src="../assets/ChatManagingEmailMidImage.png" class="chatImg1 img-fluid">
        </div>
      </div>
    </div>
    <div>
      <div class="row greyRow top13 bottom13">
        <div class="col-md-6 col-sm-12 col-xs-12">
          <img src="../assets/ChatManagingEmailWebImage2(white).png" class="chatImg1 img-fluid">
        </div>
        <div class="col-md-4 col-sm-12 col-xs-12 paddingLeftSideSmall">
          <div class="row textFormatting">
            <p class="headline">Providing answers & constantly learning.</p>
          </div>
          <div class="row textFormatting extraSpace">
            <p class="subline">ChatManaging is a hybrid breed of bot— directing prospects through the conversation while providing the information they need and leading them to book a tour. ChatManaging constantly learns and adapts as unique conversations occur.</p>
          </div>
          <div class="row extraSpace top3">
            <input type="button" class="btn whiteGreyRedButton" value="Create your first Chatbot FREE for 30 days" @click="showModal = true"/>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="row whiteRow top13 bottom13">
        <div class="col-md-12">
          <p class="headline centreText bottom6">Choose a package</p>
        </div>
        <div class="col-md-12 centreText flexDiv sidePadding">
          <div class="flexColumn marginTop3 spaceBetween">
            <div class="borderDiv top5">
              <p class="packageTitle">Pro</p>
              <p class="packageDesc">Bundled with <a class="addUnderline" href="https://www.leadmanaging.com/" target="_blank">LeadManaging</a> Online Bookings. $80 one-time set up fee required.</p>
              <p class="smallerHeadline">$69/bot/month</p>
              <p class="discount bottom4">(Discount factor applied with over 3 bots)</p>
              <div class="row greyRow top5 bottom4">
                <div class="col">
                  <p class="smallerHeadline bottom3">Included Features</p>
                  <div class="row paddingLeftSide8">
                    <img src="../assets/CheckMarkChatManaging.png" width="25" height="20" class="marginRight5">
                    <div class="col noPadding">
                      <p class="packagePoint">Up to 100 bots</p>
                    </div>
                  </div>
                  <div class="row paddingLeftSide8">
                    <img src="../assets/CheckMarkChatManaging.png" width="25" height="20" class="marginRight5">
                    <div class="col noPadding">
                      <p class="packagePoint">Chat Leads to your email</p>
                    </div>
                  </div>
                  <div class="row paddingLeftSide8">
                    <img src="../assets/CheckMarkChatManaging.png" width="25" height="20" class="marginRight5">
                    <div class="col noPadding">
                      <p class="packagePoint">LeadManaging Online Bookings</p>
                    </div>
                  </div>
                  <div class="row paddingLeftSide8">
                    <img src="../assets/CheckMarkChatManaging.png" width="25" height="20" class="marginRight5">
                    <div class="col noPadding">
                      <p class="packagePoint">LeadManaging Dashboard Reports (Limited)</p>
                    </div>
                  </div>
                  <div class="row paddingLeftSide8">
                    <img src="../assets/CheckMarkChatManaging.png" width="25" height="20" class="marginRight5">
                    <div class="col noPadding">
                      <p class="packagePoint">Resources to manage & improve bot</p>
                    </div>
                  </div>
                  <div class="row paddingLeftSide8">
                    <img src="../assets/CheckMarkChatManaging.png" width="25" height="20" class="marginRight5">
                    <div class="col noPadding">
                      <p class="packagePoint">Chatbot customization</p>
                    </div>
                  </div>
                  <div class="row paddingLeftSide8">
                    <img src="../assets/CheckMarkChatManaging.png" width="25" height="20" class="marginRight5">
                    <div class="col noPadding">
                      <p class="packagePoint">Call Tracking (1 line) & Email Tracking</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom3"></div>
            <input type="button" class="btn blueButton" value="Start with Pro ChatManaging" @click="showModal = true"/>
            <div class="bottom3"></div>
          </div>
          <div class="flexColumn frontMost spaceBetween">
            <div class="borderDiv top5">
              <p class="packageTitle">Pro+</p>
              <p class="packageDesc">Bundled with <a class="addUnderline" href="https://www.leadmanaging.com/" target="_blank">LeadManaging</a> full package. $80 one-time set up fee required.</p>
              <p class="smallerHeadline">$225/bot/month</p>
              <p class="discount bottom4">(Discount factor applied with over 3 bots)</p>
              <div class="row greyRow top5 bottom4">
                <div class="col">
                  <p class="smallerHeadline bottom3">Included Features</p>
                  <div class="row paddingLeftSide8">
                    <img src="../assets/CheckMarkChatManaging.png" width="25" height="20" class="marginRight5">
                    <div class="col noPadding">
                      <p class="packagePoint">Unlimited bots</p>
                    </div>
                  </div>
                  <div class="row paddingLeftSide8">
                    <img src="../assets/CheckMarkChatManaging.png" width="25" height="20" class="marginRight5">
                    <div class="col noPadding">
                      <p class="packagePoint">Chat Leads to your email</p>
                    </div>
                  </div>
                  <div class="row paddingLeftSide8">
                    <img src="../assets/CheckMarkChatManaging.png" width="25" height="20" class="marginRight5">
                    <div class="col noPadding">
                      <p class="packagePoint">LeadManaging Online Bookings</p>
                    </div>
                  </div>
                  <div class="row paddingLeftSide8">
                    <img src="../assets/CheckMarkChatManaging.png" width="25" height="20" class="marginRight5">
                    <div class="col noPadding">
                      <p class="packagePoint">LeadManaging Dashboard Reports (All)</p>
                    </div>
                  </div>
                  <div class="row paddingLeftSide8">
                    <img src="../assets/CheckMarkChatManaging.png" width="25" height="20" class="marginRight5">
                    <div class="col noPadding">
                      <p class="packagePoint">Automated follow up emails</p>
                    </div>
                  </div>
                  <div class="row paddingLeftSide8">
                    <img src="../assets/CheckMarkChatManaging.png" width="25" height="20" class="marginRight5">
                    <div class="col noPadding">
                      <p class="packagePoint">Dedicated resource to manage & improve bot</p>
                    </div>
                  </div>
                  <div class="row paddingLeftSide8">
                    <img src="../assets/CheckMarkChatManaging.png" width="25" height="20" class="marginRight5">
                    <div class="col noPadding">
                      <p class="packagePoint">Chatbot customization & brand removal</p>
                    </div>
                  </div>
                  <div class="row paddingLeftSide8">
                    <img src="../assets/CheckMarkChatManaging.png" width="25" height="20" class="marginRight5">
                    <div class="col noPadding">
                      <p class="packagePoint">Advertising & staff performance (Advanced Call & Email Tracking)</p>
                    </div>
                  </div>
                  <div class="row paddingLeftSide8">
                    <img src="../assets/CheckMarkChatManaging.png" width="25" height="20" class="marginRight5">
                    <div class="col noPadding">
                      <p class="packagePoint">Leasing CRM</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom3"></div>
            <input type="button" class="btn solidBlueButton" value="Start with Pro+ ChatManaging" @click="showModal = true"/>
          </div>
          <div class="flexColumn marginTop3 spaceBetween">
            <div class="borderDiv top5">
              <p class="packageTitle">Intro</p>
              <p class="packageDesc">Have a unique scenario that may need a custom pricing plan?</p>
              <p class="smallerHeadline bottom4">Set up a meeting</p>
              <div class="row greyRow top5 bottom4">
                <div class="col">
                  <p class="smallerHeadline bottom4">Custom Plan</p>
                  <input type="button" class="btn blueButton" value="Let's Chat About Pricing" onclick="window.open('https://www.leadmanaging.com/book-a-demo')"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 top13">
          <p class="subline centreText"><a class="addUnderline" href="https://www.leadmanaging.com/" target="_blank">Still not sure?</a>  See what other leasing tools we have for multifamily housing.</p>
        </div>
      </div>
    </div>
    <div>
      <div class="row darkGreyRow top13 bottom6">
        <div class="col-md-2 offset-md-7">
          <p class="whiteSubline">Need more information?</p>
        </div>
        <div class="col-md-3 centerButton">
          <input type="button" class="btn redButtonBottom" value="Request A Demo" onclick="window.open('http://hello.leadmanaging.com/application/controllers/booking.php?r=51kdQUExMDAzMTQ=')"/>
        </div>
      </div>
      <div class="row darkGreyRow bottom6">
        <div class="col-md-12">
          <p class="whiteSubline text-center">ChatManaging powered by National Efficiency Systems Inc. | 
            <a href="https://www.leadmanaging.com/privacy-policy" target="_blank" class="whiteLink">Privacy Policy</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandingPage',

  data () {
    return {
      showModal: false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media only screen and (max-width: 850px) {
  .leadLogo {
    display: flex;
    -ms-transform: scale(0.7,0.7); /* IE 9 */
    -webkit-transform: scale(0.7,0.7); /* Safari */
    transform: scale(0.7,0.7);
    float: left;
  }

  .textFormatting {
    display: flex;
    justify-content: center;
    padding-left: 20px;
    padding-right: 20px;
    width: 100%;
  }

  .extraSpace {
    width: 100% !important;
  }

  .whiteGreyRedButton {
    margin: 0px auto !important;
  }

  .flexDiv {
    flex-wrap: wrap !important;
    align-items: stretch;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .centerButton {
    text-align: center;
  }

  .whiteSubline {
    margin: 0px auto !important;
    text-align: center;
  }

  .paddingLeftSideSmall {
    padding-left: 5%;
  }

  .paddingLeftSideSpecial5 {
    padding-left: 0% !important;
  }

  .redButton {
    float: right;
    display: inline-block;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .col-xs-1 {
    width: 50%;
  }

  .modalContent {
    width: 100% !important;
    height: 100% !important;
    overflow:hidden;
  }

  .myModal {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .mondayIframe {
    height: 100vh !important;
  }
}

.pageDiv {
  position: absolute;
}

.noPadding {
  padding-left: 0 !important;
}

.flexDiv {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
}

.flexColumn {
  z-index: 1;
  position: relative;
  display: block;
  border-radius: 5px;
  background-color: #FFFFFF;
  flex-basis: 100%;
}

.borderDiv {
  -webkit-filter: drop-shadow(0px 0px 5px #d7d5d5);
  filter: drop-shadow(0px 0px 5px #d7d5d5);
  background-color: #FFFFFF;
  display: block;
  overflow: hidden;
  padding-left: 15px;
  padding-right: 15px;
}

.frontMost {
  z-index: 1000;
}

.sidePadding {
  padding-left: 5vw;
  padding-right: 5vw;
}

.chatImg1 {
  min-height: 40%;
  min-width: 40%;
}

.centreText {
  text-align: center;
}

.paddingLeftSide5 {
  padding-left: 5%;
}

.paddingLeftSideSpecial5 {
  padding-left: 5%;
}

.paddingLeftSide8 {
  padding-left: 8%;
}

.marginRight5 {
  margin-right: 5%;
}

.top3 {
  padding-top: 3vh;
}

.top5 {
  padding-top: 5vh;
}

.top13 {
  padding-top: 13vh;
}

.marginTop3 {
  margin-top: 3vh;
}

.bottom3 {
  padding-bottom: 3vh;
}

.bottom4 {
  padding-bottom: 4vh;
}

.bottom6 {
  padding-bottom: 7vh;
}

.bottom13 {
  padding-bottom: 13vh;
}

.bottom21 {
  padding-bottom: 26vh;
}

.whiteRow {
  background-color: #FFFFFF;
}

.greyRow {
  background-color: #f6f6f6;
}

.darkGreyRow {
  background-color: #363636;
}

.leadLogo {
  padding-top: 20px;
  cursor: pointer;
}

.addUnderline {
  text-decoration: underline;
  color: #4391ce;
}

.headline {
  font-family: 'Yantramanav', sans-serif;
  font-style: normal;
  font-weight: 900;
  line-height: 95%;
  margin: 0;
  color: #414243;
  font-size: 50px;
}

.smallerHeadline {
  font-family: 'Yantramanav', sans-serif;
  font-style: normal;
  font-weight: 900;
  line-height: 95%;
  margin: 0;
  color: #414243;
  font-size: 35px;
}

.subline {
  font-family: 'Yantramanav', sans-serif;
  font-style: normal;
  font-weight: 400;
  margin: 0;
  color: #414243;
  font-size: 20px;
}

.whiteSubline {
  font-family: 'Yantramanav', sans-serif;
  font-style: normal;
  font-weight: 400;
  margin: 0;
  color: #FFFFFF;
  font-size: 18px;
  padding-top: 7px;
}

.packageTitle {
  color: #414243;
  font-size: 25px;
}

.packageDesc {
  color: #9e9999;
  font-size: 15px;
  padding-right: 10px;
  padding-left: 10px;
}

.discount {
  color: #414243;
  font-size: 13px;
}

.packagePoint {
  color: #414243;
  font-size: 13px;
  text-align: left;
}

.extraSpace {
  width: 120%;
}

.redButton {
  background-color: #e43a3f;
  border-radius: 30px;
  border: 2px solid #e43a3f;
  font-family: 'Yantramanav', sans-serif;
  font-size: 17px;
  color: #FFFFFF;
  padding-left: 40px;
  padding-right: 40px;
  margin-top: 20px;
  margin-right: 5vw;
  font-weight: bold;
  white-space: nowrap;
  float: right;
}

.redButtonBottom {
  background-color: #e43a3f;
  border-radius: 30px;
  border: 2px solid #e43a3f;
  font-family: 'Yantramanav', sans-serif;
  font-size: 17px !important;
  color: #FFFFFF;
  padding-left: 40px;
  padding-right: 40px;
  margin-right: 5vw;
  font-weight: bold;
  white-space: normal;
  margin: 0;
  top: 50%;
}

.solidBlueButton {
  background-color: #4391ce;
  border: 2px solid #4391ce;
  font-family: 'Yantramanav', sans-serif;
  font-size: 17px !important;
  color: #FFFFFF;
  padding-left: 40px;
  padding-right: 40px;
  margin-top: 8px;
  white-space: normal;
  padding-top: 12px;
  padding-bottom: 12px;
}

.blueButton {
  background-color: Transparent;
  border: 2px solid #4391ce;
  font-family: 'Yantramanav', sans-serif;
  font-size: 17px !important;
  color: #4391ce;
  padding-left: 40px;
  padding-right: 40px;
  margin-top: 8px;
  white-space: normal;
  padding-top: 12px;
  padding-bottom: 12px;
}

.whiteGreyRedButton {
  background-color: Transparent;
  border-radius: 30px;
  border: 2px solid #e43a3f;
  font-family: 'Yantramanav', sans-serif;
  font-size: 17px !important;
  color: #e43a3f;
  padding-left: 40px;
  padding-right: 40px;
  margin-top: 8px;
  white-space: normal;
}

.whiteGreyRedButton:hover {
  background-color: #e43a3f;
  color: white;
}

.blueButton:hover {
  background-color: #4391ce;
  color: #FFFFFF;
}

.solidBlueButton:hover {
  background-color: #68a7d7;
  border: 2px solid #68a7d7;
}

.redButton:hover {
  background-color: #e96165;
  border: 2px solid #e96165;
}

.redButtonBottom:hover {
  background-color: #e96165;
  border: 2px solid #e96165;
}

.whiteLink {
  color: #FFFFFF;
  text-decoration: underline;
  text-decoration-color: #FFFFFF;
}

.whiteLink:hover {
  color: grey;
  text-decoration-color: grey;
}

.myModal {
  position: fixed; /* Stay in place */
  z-index: 11111111; /* Sit on top */
  padding-top: 2vh; /* Location of the box */
  padding-bottom: 2vh;
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
  display: flex;
  align-items: center;
}

/* Modal Content */
.modalContent {
  background-color: #fefefe;
  margin: auto;
  width: 60%;
}

/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  width: 28px;
  position: absolute;
  right: 25px;
  top: 5px;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.mondayIframe {
  height: 90vh;
}
</style>



// WEBPACK FOOTER //
// src/components/LandingPage.vue